<template>
  <div class="task-execute-profile-container basicStyle">
    <el-form :inline="true" :model="taskFormData" class="demo-form-inline">
      <el-form-item label="任务名称:">
        <div class="task-name">{{ allProgressData.name }}</div>
      </el-form-item>
      <el-form-item label="指标说明">
        <el-popover placement="top-start" width="200" trigger="hover">
          <div v-html="tboundswzx"></div>
          <i
            class="el-icon-question el-icon--right"
            slot="reference"
            style="margin-left: 30px"
          ></i>
        </el-popover>
        <!-- <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="taskFormData.targetExplain"
        >
          <i
            class="el-icon-question el-icon--right target-explain"
            slot="reference"
          ></i>
        </el-popover> -->
      </el-form-item>
    </el-form>
    <div class="all-progress">总进度概况：</div>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple flex-box">
          <div>数量</div>
          <div>{{ allProgressData.import_total }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple flex-box">
          <div>已分配/已执行</div>
          <div>
            <span>{{ allProgressData.fp_total }}</span> /
            <span class="activeNumber">{{ allProgressData.jx_total }}</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple flex-box">
          <div>已接通</div>
          <div>{{ allProgressData.jietong_total }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple flex-box">
          <div>计费/账户余额</div>
          <div>
            <span>{{ allProgressData.cost }}</span> /
            <span class="activeNumber">{{ allProgressData.fee }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="all-progress">员工进度概况：</div>
    <el-table :data="staffProgressData" style="width: 100%" border>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column prop="num" label="已分配" align="center">
        <template slot-scope="scope">
          <!-- 在组件内部需要通过插槽的scope来获取传递的数据 -->
          <div class="allocation" @click="toPhonePage(scope.row)">
            {{ scope.row.num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="exec_total"
        label="已执行"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="called_total"
        label="已接通"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="called_time"
        label="通话时长"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cost_time"
        label="计费时长"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cost"
        label="计费"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      class="foot-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 15, 20, 30]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import callPhoneApi from "@/api/callphone";
export default {
  name: "taskExecuteProfile", // 任务执行概况
  created() {
    // 获取问号中的显示内容
    this.getDic();
    // 获取上一个页面传过来的参数
    this.taskFormData.taskId = this.$route.query.id;
    // 获取员工进度概况
    this.getStaffProgress();
  },
  activated() {
    // 获取上一个页面传过来的参数
    this.taskFormData.taskId = this.$route.query.id;
    // 获取任务名称列表
    this.getTaskNameData();
    // 获取员工进度概况
    this.getStaffProgress();
  },
  data() {
    return {
      // 任务表单信息
      taskFormData: {
        taskId: "", // 任务名称
        targetExplain: "", // 指标说明
      },
      // 总进度概况数据
      allProgressData: {
        // 数量
        import_total: 0,
        // 已分配
        fp_total: 0,
        // 已执行
        jx_total: 0,
        // 已接通
        jietong_total: 0,
        // 计费
        cost: 0,
        // 账户余额
        fee: 0,
      },
      // 任务名称列表
      taskNameData: [],
      // 员工进度概况
      staffProgressData: [],
      // 第几页数据
      currentPage: 1,
      // 每一页几条数据
      limit: 10,
      // 总条数
      total: 0,
      tboundswzx: "",
    };
  },
  methods: {
    // 跳转到自有号码（平台号码）界面
    toPhonePage(data) {
      if (data.id > 0) {
        this.$router.push({
          path: "/callPhone",
          query: {
            type: this.allProgressData.crm_type,
            task_id: data.task_id,
            staff_id: data.staff_id,
          },
        });
      }
    },
    // 改变每一页尺寸触发的函数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getStaffProgress();
    },
    // 改变页面触发的函数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getStaffProgress();
    },
    // 获取问号中的显示内容
    getDic() {
      commonApi.getInfoToName({ name: "outwardcalsm" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key === "tboundswzx") {
              this.tboundswzx = item.value;
            }
          });
        }
      });
    },
    // 获取员工进度概况
    getStaffProgress() {
      const params = {
        task_id: this.taskFormData.taskId,
        limit: this.limit,
        page: this.currentPage,
      };
      callPhoneApi.getStaffProgress(params).then((res) => {
        if (res.code === 200) {
          console.log(res);
          this.allProgressData = res.data.task_info;
          this.staffProgressData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.task-execute-profile-container {
  .all-progress {
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .allocation {
    color: blue;
    cursor: pointer;
  }
  .foot-page {
    margin-top: 20px;
  }
}
/deep/ .target-explain {
  font-size: 40px !important;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.task-name {
  width: 300px;
}
</style>
